// @ts-ignore
import { configureStore } from '@reduxjs/toolkit';
import componentSelectedReducer from './componentSelectedSlice'

export default configureStore({
    reducer: {
        componentSelectedSlice: componentSelectedReducer
    },
});
